import React, { Component } from 'react';
import InputList from '../../../shared/components/presentation/input-list/InputList';
import { Grid, GridItem } from '../../../shared/components/presentation/grid/Grid';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as webAppointmentActions from '../../actions/webAppointmentActions';
import { nextPage } from '../../functions/nextPage';
import * as defaultState from '../../constants/DefaultState';
import * as strings from '../../constants/strings';

export class BillingPage extends Component {

  isValid() {
    let valid = this.props.insurance.whereToSend;
    return !!valid;
  }

  render() {
    const title = "Please provide billing information.";

    let inputlist = [
      {
        fieldsetLegend: "",
        fieldsetColumns: 1,
        inputs: [
          {
            type: 'radio-list',
            id: 'where-to-send',
            groupName: 'where-to-send',
            legend: 'Where should we send the bill?',
            helperText: "For services not covered by insurance (such as co-pays and deductibles).",
            required: true,
            onChange: (ev) => { this.props.webAppointmentSetInsuranceWhereToSend(ev.target.value); },
            radioWrapperClassName: 'radio-button-inline radio-button-bold',
            radioProps: this.props.forMe ? [
              {
                id: "send-to-my-address",
                label: strings.TO_MY_ADDRESS,
                value: strings.TO_MY_ADDRESS,
                checked: this.props.insurance.whereToSend === strings.TO_MY_ADDRESS
              },
              {
                id: "send-somewhere-else",
                label: strings.SOMEWHERE_ELSE,
                value: strings.SOMEWHERE_ELSE,
                checked: this.props.insurance.whereToSend !== strings.TO_MY_ADDRESS && this.props.insurance.whereToSend !== strings.TO_PATIENTS_ADDRESS && this.props.insurance.whereToSend
              }
            ] :
            [
              {
                id: "send-to-my-address",
                label: strings.TO_MY_ADDRESS,
                value: strings.TO_MY_ADDRESS,
                checked: this.props.insurance.whereToSend === strings.TO_MY_ADDRESS
              },
              {
                id: "send-to-patients-address",
                label: strings.TO_PATIENTS_ADDRESS,
                value: strings.TO_PATIENTS_ADDRESS,
                checked: this.props.insurance.whereToSend === strings.TO_PATIENTS_ADDRESS
              },
              {
                id: "send-somewhere-else",
                label: strings.SOMEWHERE_ELSE,
                value: strings.SOMEWHERE_ELSE,
                checked: this.props.insurance.whereToSend !== strings.TO_MY_ADDRESS && this.props.insurance.whereToSend !== strings.TO_PATIENTS_ADDRESS && this.props.insurance.whereToSend
              }
            ] // end of radioProps
          }  // end of radio-list input.
        ]  // end of inputs for first fieldset
      },  // end of fieldset
      {
        fieldsetLegend: "",
        fieldsetColumns: 1,
        className: "button-order margin-top-medium",
        inputs: [
          [
            {
              type: 'button',
              id: "back",
              className: "btn--secondary",
              value: 'Back',
              onClick: () => {
                this.props.history.goBack();
              }
            },
            {
              type: 'button',
              id: "next",
              className: "btn--primary",
              value: "Next",
              disabled: !this.isValid(),
              onClick: () => {
                this.props.history.push(nextPage(null, {
                  forMe: this.props.forMe,
                  patientSeenRecently: this.props.patientSeenRecently,
                  insurance: this.props.insurance
                }));
              }
            }
          ]
        ]
      }
    ];

    return (
      <React.Fragment>
        <Grid columns={1}>
          <GridItem>
            <div className='web-appt__header'>
              <h1>{title}</h1>
              <hr />
            </div>
          </GridItem>
        </Grid>
        <InputList inputs={inputlist} isInlineList={false} />
      </React.Fragment>
    );
  }
}

BillingPage.propTypes = {
  insurance: defaultState.insurancePropType,
  patientSeenRecently: PropTypes.bool.isRequired,
  forMe: PropTypes.bool.isRequired,
  webAppointmentSetInsuranceWhereToSend: PropTypes.func.isRequired
};

function mapStateToProps(state, ownProps) {
  return {
    insurance: state.webAppointmentForm.insurance,
    patientSeenRecently: state.webAppointmentForm.patientSeenRecently,
    forMe: state.webAppointmentForm.forMe
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    webAppointmentSetInsuranceWhereToSend: (value) => dispatch(webAppointmentActions.webAppointmentSetInsuranceWhereToSend(value))
  };
};

// connects component to redux, and passes along the router
export default connect(mapStateToProps, mapDispatchToProps)(BillingPage);
